var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8 10l7.8-7.9c.5-.4.5-1.2 0-1.7-.4-.5-1.2-.5-1.7 0L10 8.2 2.1.4C1.7-.1 1-.1.4.4-.1.8-.1 1.6.4 2l7.8 8-7.8 7.8c-.5.5-.5 1.3 0 1.7.2.3.5.4.8.4.4 0 .7-.1 1-.4l7.8-7.8 7.9 7.8c.2.3.5.4.8.4a1.2 1.2 0 001-2.1l-8-7.9z"}));
}

Cross.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Cross;

Cross.default = Cross;
